import { render } from "./DjHeader.vue?vue&type=template&id=8f024e1a&scoped=true"
const script = {}

import "./DjHeader.vue?vue&type=style&index=0&id=8f024e1a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\gaole\\Documents\\work\\dc\\www.tzspace.cn\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f024e1a"]])

export default __exports__